// extracted by mini-css-extract-plugin
module.exports = {"link":"articles-cards-list_link__xS2bP","listItem":"articles-cards-list_listItem__dDXp1"};